import { Component, Input, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../user/services/user.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', '../../../../scss/app-styles.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() public nav?: MatSidenav;
  userService = inject(UserService);
  translate = inject(TranslateService);
  user = signal(this.userService.getUser().getValue());

  private userSubscription?: Subscription;

  language_picker_open = false;
  langages = ['fr', 'en'];

  ngOnInit() {
    // Subscribe to user changes and update the signal accordingly
    this.userSubscription = this.userService.getUser().subscribe(user => {
      this.user.set(user);
    });
  }

  ngOnDestroy() {
    this.userSubscription?.unsubscribe();
  }

  selectLanguage(lang: string) {
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    this.language_picker_open = false;
  }
}
